import './App.css';
import Sidebar from './sidebar';
import { Routes,Route, BrowserRouter, HashRouter, Link, useNavigate } from 'react-router-dom';
import Banner from './Master/Banner';
import { BannerAdd } from './Master/Addbannerform.js';
import { AddRoomsPanel, RoomAdd, EditRoom, ViewRoom, EditRoomImage, EditRoomType } from './Master/AddRooms.js';
import { LocationPanel, EditAddress, NearPointAdd, EditNearPoint, ViewNearPoint } from "./Location/Address.js";
import { GalleryHome, AddGallery, EditGallery, ViewGallery } from "./Gallery/Gallery.js"
import { AmenitiesPanel, AmenitiesAdd, EditAmenities, ViewAminities } from "./Amenities/Amenities.js"
import { ContactPanel } from "./Contact/Contact.js"
import { EditPolicies, PolicesPanel, PoliciesAdd } from "./Policies/Policies.js"
import {FeedbackPanel} from "./Feedback/Feedback.js"
import { EditBanner } from './Master/updatebanner.js';
import ViewBanner from './Master/ViewBanner.js';
import { ContactdetailsPanel, EditContactDetails } from './Contact/ContactDetail.js';
import Dashboard from './Master/Dashboard.js';
import { EditHomeDetail, HomeDetailPanel } from './Master/HomeDetail.js';
import { Blog, BlogAdd, EditBlog, ViewBlog } from './Blog.js';
import { BookingPanel } from './Booking/Booking.js';
import { EditHomeDescription, HomeDescriptionAdd, HomeDescriptionPanel } from './Master/HomeDescription.js';


function App() {
  
   const handleLogout = () => {
  // Clear login flag
  localStorage.removeItem("loggedIn");


  // Redirect to login page
  window.location.hash = "/";
  window.location.reload();
};


  return (
    <div className='app-section'>
    <div className='top-nav'>
       <div className="topbar">
        <button onClick={handleLogout}>Logout</button>
      </div>
      </div>
      
        <div style={{ display: 'flex', minHeight: '100vh' }}>
          
          <div className="layout-container" style={{ width: '20%', backgroundColor: '#2c3e50' }}>
            <Sidebar />
          </div>
          
          <div className="main-content" style={{ flex: 1, padding: '10px', width:'80%', marginLeft:'20px',  }}>
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />

               {/* Home Detail section */}
              <Route path="/Master/HomeDetail" element={<HomeDetailPanel />} />
              <Route path="/Master/HomeDetail-edit/:id" element={<EditHomeDetail />} />

              {/* Home Description section */}    
              <Route path="/Master/HomeDescription" element={<HomeDescriptionPanel />} />
              <Route path="/Master/HomeDescription-add" element={<HomeDescriptionAdd/>} />
              <Route path="/Master/HomeDescription-edit/:id" element={<EditHomeDescription/>} />
              {/* <Route path="/Master/HomeDescription/:id" element={<ViewBanner />} /> */}

              {/* Banner section */}    
              <Route path="/Master/Banner" element={<Banner />} />
              <Route path="/Master/Addbannerform" element={<BannerAdd />} />
              <Route path="/update-banner/:id" element={<EditBanner />} />
              <Route path="/view-banner/:id" element={<ViewBanner />} />

              {/* Room section */}
              <Route path="/Master/AddRooms" element={<AddRoomsPanel />} />
              <Route path="/Master/AddRooms-add" element={<RoomAdd />} />
              <Route path="/Master/AddRooms-editimage/:id" element={<EditRoomImage />} />
              <Route path="/Master/AddRooms-editdata/:id" element={<ViewRoom />} />
              <Route path="/Master/AddRooms-edit/:id" element={<EditRoomType />} />

              {/* Location */}
              <Route path="/Location/Address" element={<LocationPanel />} />
              <Route path="/add-location" element={<NearPointAdd />} />
              <Route path="/Edit-Location/:id" element={<EditAddress />} />
              <Route path="/Edit/Location/Address/:id" element={<EditNearPoint />} />
              <Route path="/View/Location/Address/:id" element={<ViewNearPoint />} />

              {/* Gallery section */}
              <Route path="/Gallery" element={<GalleryHome />} />
              <Route path="/Gallery-add" element={<AddGallery />} />
              <Route path="/Gallery-edit/:id" element={<EditGallery />} />
              <Route path="/Gallery-view" element={<ViewGallery />} />

              {/* Amenities section */}
              <Route path="/Amenities" element={<AmenitiesPanel />} />
              <Route path="/Amenities-add" element={<AmenitiesAdd />} />
              <Route path="/Amenities-edit/:id" element={<EditAmenities />} />
              <Route path="/Amenities-view/:id" element={<ViewAminities />} />

              {/* Contact section */}
              <Route path="/Contact" element={<ContactPanel />} />

              {/* Contact Detail section */}
              <Route path="/Contact-Detail" element={<ContactdetailsPanel />} />
              <Route path="/Contact-Detail-edit/:id" element={<EditContactDetails />} />


              {/* Policies section */}
              <Route path="/Policies" element={<PolicesPanel />} />
              <Route path="/Policies-add" element={<PoliciesAdd />} />
              <Route path="/Edit/Policies/:id" element={<EditPolicies />} />

              {/* Feedback section */}
              <Route path="/Feedback" element={<FeedbackPanel />} />

              <Route path='/Blog' element={<Blog/>}/>
              <Route path='/Blog-add' element={<BlogAdd/>}/>
              <Route path='/Blog-edit/:id' element={<EditBlog/>}/>
              <Route path='/Blog-view/:id' element={<ViewBlog/>}/>

              <Route path='/Booking' element={<BookingPanel/>} />

            </Routes>
          </div>
        </div>
      </div>
  );
}
export default App;
